import styled from 'styled-components';

import media from '../../../styles/media.style';
import { BG_GRAY, WHITE, BLACK, SCREEN_LOCKUP_WIDTH } from '../../../styles/variables.style';

export const Wrapper = styled.section`
  padding: 20px 0;
  margin-top: 20px;
  background-color: ${BG_GRAY.COMMON_1};
  color: ${BLACK};

  ${media.tabletL`
    margin-top: 60px;
  `};
`;

export const Contents = styled.div`
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  margin: 0 auto 50px;
  ${media.tabletL`
    margin: 0 auto 100px;
  `};
`;

export const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-top: 5px;
  padding: 0 16px;
  ${media.tabletL`
    flex-direction: row;
    margin-top: 0;
    padding: 0;
  `};
`;
export const Item = styled.div`
  width: 32%;
  margin: 50px 1.3% 0 0;
  height: 395px;
  background-color: ${WHITE};
`;

export const ItemMb = styled.div`
  width: 100%;
  background-color: ${WHITE};
  margin-top: 15px;
  a {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    div:first-child {
      flex-shrink: 0;
    }
  }
`;

export const ItemTitleMb = styled.div`
  padding: 10px 10px 10px 15px;
  text-transform: uppercase;
  flex-grow: 1;
  white-space: pre-wrap;
  word-break: break-all;
`;

export const ItemContents = styled.div`
  width: 100%;
  height: 195px;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

export const ItemTitle = styled.div`
  font-size: 22px;
  line-height: 28px;
  margin-bottom: 10px;
  white-space: pre-wrap;
  overflow: hidden;
  word-break: break-all;
  max-height: 56px;
  flex-shrink: 0;
  text-transform: uppercase;
`;
export const ItemDescription = styled.div`
  font-size: 16px;
  line-height: 23px;
  overflow: hidden;
  white-space: pre-wrap;
  word-break: break-all;
`;

export const MoreButton = styled.div`
  width: 220px;
  height: 53px;
  text-align: center;
  line-height: 53px;
  background-color: ${BLACK};
  color: ${WHITE};
  font-size: 12px;
  font-weight: 800;
  margin: 60px auto 0 auto;
  cursor: pointer;
  text-transform: uppercase;

  ${media.tabletL`
    width: 228px;
    font-size: 14px;
    height: 72px;
    line-height: 72px;
    margin: 80px auto 0 auto;
`};
`;

export const Title = styled.div`
  font-size: 22px;
  text-align: center;
  margin-top: 60px;
  letter-spacing: 0.5px;
  ${media.tabletL`
    font-size: 30px;
    margin-top: 108px;
  `};
`;

export const TagSection = styled.div`
  margin: 40px auto;
  width: 100%;
  text-align: center;
  // h2 {
  //   font-size: 18px;
  // }
  ${media.tabletL`
    margin: 58px auto 8px;;
    width: 560px;
  `};
`;

export const TagSectionTitle = styled.h1`
  font-size: 12px;
  font-weight: 800;
  margin: 0;
  ${media.tabletL`
    font-size: 18px;
    font-weight: unset;
    width: 560px;
  `};
`;

export const TagList = styled.div`
  margin: 12px auto 10px;
  padding: 0 20px;
  max-height: ${({ opened, maxHeight }) => (opened ? 'unset' : `${maxHeight[0]}px`)};
  overflow: hidden;
  > div {
    display: flex;
    flex-wrap: wrap;
  }
  ${media.tabletL`
    margin: 10px auto;
    padding: 0;
    margin-top: 20px;
    max-height: ${({ opened, maxHeight }) => (opened ? 'unset' : `${maxHeight[1]}px`)};
  `};
`;

export const Tag = styled.div`
  margin: 7.5px 5px;
  padding: 0 12px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  letter-spacing: 0.2px;
  background-color: ${({ selected }) => (selected ? BLACK : WHITE)};
  color: ${({ selected }) => (selected ? WHITE : BLACK)};
  border: 1px solid ${BLACK};
  border-radius: 14px;
  text-align: center;
  cursor: pointer;
  ${media.tabletL`
    margin: 10px;
    height: 33px;
    line-height: 33px;
    font-size: 16px;
    border-radius: 17px;
  `};
`;

export const MoreTag = styled.div`
  ${media.tabletL`
    margin-top: 30px;
  `};
  img {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: 10px;
  }
  span {
    text-decoration: underline;
    position: relative;
    cursor: pointer;
  }

  ${({ opened }) =>
    !opened &&
    `
    span:after {
      content: '';
      display: inline-block;
      width: 3px;
      height: 13px;
      background-color: ${BLACK};
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(20px, -1px);
    }
  `};

  span:before {
    content: '';
    display: inline-block;
    width: 13px;
    height: 3px;
    background-color: ${BLACK};
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(25px, 4px);
  }
`;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/PastArticles/PastArticles.style.js